import { createFileRoute } from '@tanstack/react-router';
import { PaymentsOnboardingPage } from '@/components/finance/payments';

export const Route = createFileRoute('/admin/finance/payments')({
  component: PaymentsOnboardingPage,
});
